import { render, staticRenderFns } from "./opt_labels.vue?vue&type=template&id=2fa9cb85&scoped=true&lang=html"
import script from "./opt_labels.vue?vue&type=script&lang=js"
export * from "./opt_labels.vue?vue&type=script&lang=js"
import style0 from "./opt_labels.vue?vue&type=style&index=0&id=2fa9cb85&prod&lang=css"
import style1 from "./opt_labels.vue?vue&type=style&index=1&id=2fa9cb85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa9cb85",
  null
  
)

export default component.exports